module.exports = __webpack_public_path__ + "img/logo.8fb8f2ec.png";